@for (item of previewItems; track item.url) {
    @if (item.url) {
        <tec-file-preview
            [fileUrl]="item.url"
            [label]="item.label"
            [sizeSm]="item.sizeSm"
            (click)="showViewMedia(item.url)"
        />
    }
}
